<template>
  <section :class="$style.card">
    <div>
      <p :class="$style.heading">{{ heading }}</p>
      <p :class="$style.annotaion">{{ annotation }}</p>
    </div>
    <p v-if="rank" :class="[$style.rank, $style[`rank--style${rank}`]]">
      {{ rank }}
    </p>
    <slot name="content" />
    <p v-if="text" :class="$style.text">
      {{ text }}
    </p>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  heading: string
  annotation?: string
  rank?: string
  text?: string
}>()
</script>

<style lang="scss" module>
.card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1px solid $color-border-low-emphasis;
  border-radius: $border-radius-v2-rounder;
  box-shadow: $shadow-8;
}

.heading {
  font-size: 18px;
  font-weight: bold;
  line-height: 32px;
}

.annotaion {
  font-size: 10px;
  color: $color-text-and-object-medium-emphasis;
}

.rank {
  font-size: 64px;
  font-weight: bold;
  line-height: 1;

  &--styleA {
    color: $color-label-blue;
  }

  &--styleB {
    color: $color-label-green;
  }

  &--styleC {
    color: $color-label-yellow;
  }

  &--styleD {
    color: $color-label-orange;
  }

  &--styleE {
    color: $color-label-red;
  }
}

.text {
  font-size: 12px;
  margin-top: auto;
}
</style>
